import React from 'react';
import { FaChartLine } from 'react-icons/fa';

interface IndustryTrendsCardProps {
  trends: any[];
  onSeeAll?: () => void;
}

const IndustryTrendsCard: React.FC<IndustryTrendsCardProps> = ({ trends, onSeeAll }) => {
  return (
    <div className="border rounded-lg p-4 bg-white shadow-sm">
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-lg font-semibold">Industry Trends</h2>
        <button 
          className="text-blue-600 text-sm hover:text-blue-800 transition-colors cursor-pointer"
          onClick={onSeeAll}
        >
          See All →
        </button>
      </div>
      <ul className="space-y-2 text-sm">
        {trends.slice(0, 3).map((item, index) => (
          <li key={index} className="flex items-start gap-2">
            <FaChartLine className="mt-0.5 text-purple-500" />
            <span>{item.TrendHighlights}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default IndustryTrendsCard;